import { Dropdown } from "components/ui";
import { PLACEMENT } from "components/ui/utils/constant";
import { useContext, useEffect, useState } from "react";
import { LuGlobe, LuLock, LuUserCheck, LuUsers } from "react-icons/lu";
import { CompanyContext } from "contexts/CompanyContext";

const TiktokPrivacyLevelDropdown = ({
    post,
    isEditable = true,
    onChange = (privacy_level) => void 0,
    portal = false
}) => {

    const tiktokPrivacyLevelsOptions = [
        { id: "PUBLIC_TO_EVERYONE", name: "Public to everyone", description: "Content is visible to everyone on TikTok", icon: <LuGlobe className="text-3xl shrink-0 text-primary-600" /> },
        { id: "FOLLOWER_OF_CREATOR", name: "Followers of creator", description: "Content is visible to the creator's followers only", icon: <LuUsers className="text-3xl shrink-0 text-purple-500" /> },
        { id: "MUTUAL_FOLLOW_FRIENDS", name: "Mutual follow friends", description: "Content is visible to friends who are mutually following each other", icon: <LuUserCheck className="text-3xl shrink-0 text-fuchsia-600" /> },
        { id: "SELF_ONLY", name: "Self only", description: "Content is visible to the creator themselves only", icon: <LuLock className="text-3xl shrink-0 text-red-600" /> }
    ];
    
    const { companySocials } = useContext(CompanyContext);
    const integration = companySocials?.find(e => e.type == "tiktok");
    const [ tiktokPrivacyLevels, setTiktokPrivacyLevels ] = useState(tiktokPrivacyLevelsOptions?.filter(e => integration?.preferences?.privacy_level_options?.includes(e?.id)));
    const tiktokPrivacyLevel = tiktokPrivacyLevelsOptions?.find(e => e.id == post?.preferences?.privacy_level) || tiktokPrivacyLevelsOptions?.[0];

    const disabled = !isEditable || !integration;

    useEffect(() => {
        if (!post?.preferences?.privacy_level || !tiktokPrivacyLevels?.find(e => e.id == post?.preferences?.privacy_level)) {
            onChange(tiktokPrivacyLevels?.[0]?.id);
        }
    }, [tiktokPrivacyLevels, post?.preferences?.privacy_level]);


    return (
        <Dropdown
            placement={PLACEMENT.BOTTOM_START}
            parentClassName="flex-1 w-[60%]"
            menuClass={`w-auto ${portal ? "" : "w-full"} p-0 overflow-y-auto`}
            portal={portal}
            disabled={disabled}
            renderTitle={
                <div className={`w-full !p-4 border-b border-tertiary-100 dark:border-gray-700 cursor-pointer ${disabled && `!cursor-default hover:bg-tertiary-50 dark:hover:bg-gray-700`}`}>
                    <div className='flex items-center gap-2.5'>
                        {tiktokPrivacyLevel?.icon}
                        <div className="flex flex-col w-full overflow-hidden">
                            <b className="font-black text-tertiary-700 dark:text-gray-200">{tiktokPrivacyLevel?.name}</b>
                            <small className="text-xs font-normal w-full whitespace-nowrap overflow-hidden text-ellipsis">{tiktokPrivacyLevel?.description}</small>
                        </div>
                    </div>
                </div>
            }
        >
            {tiktokPrivacyLevels?.map((_tiktokPrivacyLevel, key) => (
                <Dropdown.Item key={_tiktokPrivacyLevel?.id} onClick={() => onChange(_tiktokPrivacyLevel?.id)} className={`flex items-center gap-2.5 py-2 px-4 ${tiktokPrivacyLevel?.id == _tiktokPrivacyLevel?.id && `bg-primary-50 dark:bg-primary-900`}`}>
                    {_tiktokPrivacyLevel?.icon}
                    <div className="flex flex-col flex-1">
                        <b>{_tiktokPrivacyLevel?.name}</b>
                        <small className="font-normal">{_tiktokPrivacyLevel?.description}</small>
                    </div>
                </Dropdown.Item>
            ))}
        </Dropdown>
    )
}

export default TiktokPrivacyLevelDropdown;